"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadingMode = exports.CurveMode = exports.NotificationDestination = exports.NotificationType = exports.CurrencyInternalCode = exports.ReleaserStatus = exports.TrapCountingMethod = exports.ReleaseRateUnit = exports.DocumentType = exports.PaymentStatus = exports.PaymentFrequency = exports.ReleaserAction = exports.DroneAction = exports.CpuBlockStatus = exports.CpuBlockReason = exports.UnitSystem = exports.Role = void 0;
var Role;
(function (Role) {
    /** Role of the NCB superuser. */
    Role[Role["master"] = 1] = "master";
    /** Role of an admin of an individual direct client. */
    Role[Role["admin"] = 2] = "admin";
    /** Role of a company's manager. */
    Role[Role["manager"] = 3] = "manager";
    /** Role of an operator. */
    Role[Role["operator"] = 4] = "operator";
    /** Role of an external user that corresponds to an indirect client. */
    Role[Role["external"] = 5] = "external";
})(Role = exports.Role || (exports.Role = {}));
var UnitSystem;
(function (UnitSystem) {
    UnitSystem[UnitSystem["metric"] = 1] = "metric";
    UnitSystem[UnitSystem["imperial"] = 2] = "imperial";
})(UnitSystem = exports.UnitSystem || (exports.UnitSystem = {}));
var CpuBlockReason;
(function (CpuBlockReason) {
    CpuBlockReason[CpuBlockReason["default"] = 1] = "default";
    CpuBlockReason[CpuBlockReason["idleness"] = 2] = "idleness";
    CpuBlockReason[CpuBlockReason["manuallyBlocked"] = 3] = "manuallyBlocked";
})(CpuBlockReason = exports.CpuBlockReason || (exports.CpuBlockReason = {}));
var CpuBlockStatus;
(function (CpuBlockStatus) {
    CpuBlockStatus[CpuBlockStatus["pendingBlock"] = 1] = "pendingBlock";
    CpuBlockStatus[CpuBlockStatus["blockApplied"] = 2] = "blockApplied";
    CpuBlockStatus[CpuBlockStatus["pendingUnblock"] = 3] = "pendingUnblock";
})(CpuBlockStatus = exports.CpuBlockStatus || (exports.CpuBlockStatus = {}));
var DroneAction;
(function (DroneAction) {
    DroneAction[DroneAction["enableLeds"] = 1] = "enableLeds";
    DroneAction[DroneAction["disableLeds"] = 2] = "disableLeds";
    DroneAction[DroneAction["toggleLeds"] = 3] = "toggleLeds";
    /**
     * A hover action has a single parameter (a number) specifying the
     * duration in seconds.
     */
    DroneAction[DroneAction["hover"] = 4] = "hover";
})(DroneAction = exports.DroneAction || (exports.DroneAction = {}));
var ReleaserAction;
(function (ReleaserAction) {
    ReleaserAction[ReleaserAction["release"] = 1] = "release";
    ReleaserAction[ReleaserAction["stopRelease"] = 2] = "stopRelease";
})(ReleaserAction = exports.ReleaserAction || (exports.ReleaserAction = {}));
var PaymentFrequency;
(function (PaymentFrequency) {
    PaymentFrequency[PaymentFrequency["once"] = 1] = "once";
    PaymentFrequency[PaymentFrequency["monthly"] = 2] = "monthly";
    PaymentFrequency[PaymentFrequency["yearly"] = 3] = "yearly";
})(PaymentFrequency = exports.PaymentFrequency || (exports.PaymentFrequency = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus[PaymentStatus["paidOnDueDate"] = 1] = "paidOnDueDate";
    PaymentStatus[PaymentStatus["paidInAdvance"] = 2] = "paidInAdvance";
    PaymentStatus[PaymentStatus["paidLate"] = 3] = "paidLate";
    PaymentStatus[PaymentStatus["latePending"] = 4] = "latePending";
})(PaymentStatus = exports.PaymentStatus || (exports.PaymentStatus = {}));
var DocumentType;
(function (DocumentType) {
    DocumentType[DocumentType["cpf"] = 1] = "cpf";
    DocumentType[DocumentType["cnpj"] = 2] = "cnpj";
    DocumentType[DocumentType["iva"] = 3] = "iva";
})(DocumentType = exports.DocumentType || (exports.DocumentType = {}));
var ReleaseRateUnit;
(function (ReleaseRateUnit) {
    ReleaseRateUnit[ReleaseRateUnit["volume"] = 1] = "volume";
    ReleaseRateUnit[ReleaseRateUnit["cup"] = 2] = "cup";
})(ReleaseRateUnit = exports.ReleaseRateUnit || (exports.ReleaseRateUnit = {}));
var TrapCountingMethod;
(function (TrapCountingMethod) {
    TrapCountingMethod[TrapCountingMethod["manual"] = 1] = "manual";
    TrapCountingMethod[TrapCountingMethod["automatic"] = 2] = "automatic";
    TrapCountingMethod[TrapCountingMethod["semiAutomatic"] = 3] = "semiAutomatic";
})(TrapCountingMethod = exports.TrapCountingMethod || (exports.TrapCountingMethod = {}));
var ReleaserStatus;
(function (ReleaserStatus) {
    ReleaserStatus[ReleaserStatus["requested"] = 1] = "requested";
    ReleaserStatus[ReleaserStatus["recorded"] = 2] = "recorded";
    ReleaserStatus[ReleaserStatus["receivedByClient"] = 3] = "receivedByClient";
    ReleaserStatus[ReleaserStatus["sentToNCB"] = 4] = "sentToNCB";
    ReleaserStatus[ReleaserStatus["receivedByNCB"] = 5] = "receivedByNCB";
    ReleaserStatus[ReleaserStatus["underMaintenance"] = 6] = "underMaintenance";
    ReleaserStatus[ReleaserStatus["irrecoverable"] = 7] = "irrecoverable";
    ReleaserStatus[ReleaserStatus["blocked"] = 8] = "blocked";
})(ReleaserStatus = exports.ReleaserStatus || (exports.ReleaserStatus = {}));
var CurrencyInternalCode;
(function (CurrencyInternalCode) {
    CurrencyInternalCode[CurrencyInternalCode["BRL"] = 1] = "BRL";
    CurrencyInternalCode[CurrencyInternalCode["EUR"] = 2] = "EUR";
    CurrencyInternalCode[CurrencyInternalCode["USD"] = 3] = "USD";
})(CurrencyInternalCode = exports.CurrencyInternalCode || (exports.CurrencyInternalCode = {}));
var NotificationType;
(function (NotificationType) {
    // ! Preencher de acordo com a resposta do Nicodemos
    NotificationType[NotificationType["test"] = 1] = "test";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
var NotificationDestination;
(function (NotificationDestination) {
    NotificationDestination[NotificationDestination["web"] = 1] = "web";
    NotificationDestination[NotificationDestination["mobile"] = 2] = "mobile";
    NotificationDestination[NotificationDestination["both"] = 3] = "both";
})(NotificationDestination = exports.NotificationDestination || (exports.NotificationDestination = {}));
var CurveMode;
(function (CurveMode) {
    CurveMode[CurveMode["curved"] = 1] = "curved";
    CurveMode[CurveMode["normal"] = 2] = "normal";
})(CurveMode = exports.CurveMode || (exports.CurveMode = {}));
var HeadingMode;
(function (HeadingMode) {
    HeadingMode[HeadingMode["manual"] = 1] = "manual";
    HeadingMode[HeadingMode["nextWaypoint"] = 2] = "nextWaypoint";
})(HeadingMode = exports.HeadingMode || (exports.HeadingMode = {}));
